import { Lightbulb } from "lucide-react";
import { useTaal } from "@/contexts/TaalContext";

/**
 * C1 punt 3, 15 oktober 2026: wat je op het Code-scherm kunt doen, met drie
 * voorbeelden die Frank koos (CSV's samenvoegen, marges doorrekenen, bestanden
 * hernoemen).
 *
 * **EEN KLIK ZET DE OPDRACHT IN HET VAK EN VOERT HAAR NIET UIT.** Code draaien
 * blijft een eigen klik op "Start de agent": wie een voorbeeld aanklikt, ziet
 * eerst wat er gaat gebeuren en kan het aanpassen aan zijn eigen bestanden.
 */
export const VOORBEELDEN = [
  {
    knop: "CSV's samenvoegen",
    opdracht: "Voeg alle CSV-bestanden in deze map samen tot een bestand samen.csv, met de kopregel een keer bovenaan, en meld hoeveel rijen er uit elk bestand kwamen.",
  },
  {
    knop: "Marges doorrekenen",
    opdracht: "Reken in prijzen.csv per regel de marge uit als (verkoopprijs - inkoopprijs) / verkoopprijs, zet die als nieuwe kolom erbij en geef de gemiddelde marge.",
  },
  {
    knop: "Bestanden hernoemen",
    opdracht: "Hernoem alle bestanden in deze map naar kleine letters met streepjes in plaats van spaties, en toon eerst de lijst oud naar nieuw voordat je iets hernoemt.",
  },
];

export default function CodeVoorbeelden({ onKies }) {
  const { t } = useTaal();
  return (
    <section className="rounded-lg border p-3 space-y-2" data-testid="code-uitleg">
      <p className="text-sm">
        {t("Hier laat je NovaMund code schrijven en uitvoeren in een afgesloten map op deze machine. Typ onderaan een opdracht in gewone taal, of kies een voorbeeld; je ziet de opdracht eerst in het vak en start hem zelf.")}
      </p>
      <div className="flex flex-wrap gap-2">
        {VOORBEELDEN.map((v) => (
          <button
            key={v.knop}
            type="button"
            onClick={() => onKies(t(v.opdracht))}
            className="tap-target inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs hover:bg-accent"
            data-testid="code-voorbeeld"
          >
            <Lightbulb className="h-3.5 w-3.5" aria-hidden="true" />
            {t(v.knop)}
          </button>
        ))}
      </div>
    </section>
  );
}
